import { Link } from 'react-router';
import { ArrowUpRight } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from '@/components/ui/card';

type Props = {
  title: string;
  description: string;
  icon: React.ElementType;
  href: string;
  linkText: string;
};

const ResourceCard = ({ title, description, icon: Icon, href, linkText }: Props) => {
  return (
    <Card className="flex flex-col hover:bg-accent transition-colors duration-300">
      <CardHeader className="pb-4 shrink-0">
        <Icon className="size-6" />
      </CardHeader>
      <CardContent className="space-y-1.5 grow">
        <CardTitle className="font-semibold">{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardContent>
      <CardFooter className="py-4 border-t shrink-0">
        <Link to={href} target="_blank" className="flex items-center gap-2 text-foreground! text-sm font-medium w-full">
          {linkText} <ArrowUpRight className="size-4" />
        </Link>
      </CardFooter>
    </Card>
  );
};

export default ResourceCard;
